import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root',
})
export class HandleInnerHtmlService {
  constructor(private appService: AppService) {}

  handleSpecialChar(value: string): string {
    if (!value) return value;
    if (value.includes('${domain}')) {
      const domain = window.location.origin;
      const languageCode = this.appService.languageCode;
      value = value.replace(/\$\{domain\}/g, `${domain}/${languageCode}`);
    }
    return value;
  }
}
